import { RiderView } from '@app/facade-services/rider-view/model/rider-view';
import { Fence } from '@app/rest-client/faxe/models/fence';
import { duration, formatDateUTC,  isNotEmpty } from '@app/fremework/functions';
import { RiderEventType } from '@app/constants/rider-event-type';
import { RiderEvent } from '@app/rest-client/faxe/models/rider-event';
import { RaceView } from '@app/facade-services/race-view/model/race-view';
import { RaceGuid } from '@app/domain/model/raceGuid';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { FenceResult } from '@app/rest-client/faxe/models/fence-result';


export const getRiderLastFenceSequence = (riderView: RiderView): number => {
  const sorted = riderView
    ?.fenceResults
    .slice()
    ?.sort((a, b) => b.renumberedSequence - a.renumberedSequence);


  if (isNotEmpty(sorted)) {
    return sorted[0]?.sequence;
  }
  return 0;
};

export const raceViewClassFences = (raceView: RaceView, raceClassGuid: string): Fence[] =>
  raceView.raceClassView
    .filter(rc => rc.raceClassGuid === raceClassGuid)
    .flatMap(rc => rc.fences);

export const requiredSliceState = (allRequired: boolean): SliceState =>
  allRequired ? SliceState.total: SliceState.reportable;

export const notEmptyByRace = (models: RaceGuid[], raceGuid: string): boolean =>
 isNotEmpty(models
    .filter(m => m?.raceGuid === raceGuid))

export const notEmptyByRaceSliceState = (models: RaceGuid[], raceGuid: string, requiredSliceState: SliceState, actualState: SliceState): boolean =>
  sliceStateSufficient(requiredSliceState, actualState) && isNotEmpty(models
    .filter(m => m?.raceGuid === raceGuid))

export const sliceStateSufficient = (requiredSliceState: SliceState, actualSliceState: SliceState): boolean =>
  actualSliceState === SliceState.total || actualSliceState == requiredSliceState;

export const raceViewFences = (raceView: RaceView): Fence[] =>
  raceView.raceClassView
    .flatMap(rc => rc.fences);

export const getRiderLastFenceName = (riderView: RiderView): string => {
  const sorted = riderView
    ?.fenceResults
    .slice()
    ?.sort((a, b) => b.sequence - a.sequence);

  if (isNotEmpty(sorted)) {
    return sorted[0].fenceName;
  }
  return undefined;
};

export const hasAllResult = (riderView: RiderView, selectedFenses: Fence[]): boolean => {
  const fenseResultsName = riderView?.fenceResults?.map(fr => fr.fenceName);
  const match = selectedFenses?.filter(sf => fenseResultsName.find(frn => frn === sf.fenceName));
  return match?.length === selectedFenses?.length;
};

export const raceDuration = (riderView: RiderView): string => {
  let start = riderEventTimestamp(riderView.riderEvents, RiderEventType.started);

  if (start) {
    const finish = riderEventTimestamp(riderView.riderEvents, RiderEventType.finished);
    if (finish) {
      return duration(start, finish);
    }
    return duration(suffixZ(start), formatDateUTC(new Date()));
  }
  return undefined;
};

export const raceDurationOnFinish = (riderView: RiderView, finish: Date): string => {
  let start = riderEventTimestamp(riderView.riderEvents, RiderEventType.started);
  if (start) {
    if (finish) {
      return duration(suffixZ(start), formatDateUTC(finish));
    }
    return duration(suffixZ(start), formatDateUTC(new Date()));
  }
  return undefined;
};

export const riderEventTimestamp = (riderEvents: RiderEvent[], eventType: RiderEventType): string =>
  riderEvents?.find(r => r.eventType === eventType)?.eventTimestamp;

export const suffixZ = (s: string): string =>
  s?.endsWith('Z') ? s : s + 'Z';

export const sortWheight = (riderView: RiderView): number => {

  if (isNotEmpty(riderView.riderEvents)) {

    const started = riderView.riderEvents.find(e => e.eventType === RiderEventType.started);
    if (started) {

      const parts = started.eventTimestamp.split('T')[1]
        .split(':');
      return +((+parts[0]).toString() + (+parts[1]).toString() + (+parts[2]).toString());
    }
  }
  return (riderView.horseCombinationNumber + 1000) * -1;

};

export const filterHighestGeneration = (
  fenceResults: FenceResult[],
  allGeneration: boolean
): FenceResult[] => {
  if (allGeneration) {
    return fenceResults;
  }
  const map = new Map<string, FenceResult>();
  for (const result of fenceResults) {
    const key = `${result.fenceGuid}_${result.riderGuid}`;
    const existing = map.get(key);
    if (
      !existing ||
      (result.resultGeneration ?? 0) > (existing.resultGeneration ?? 0)
    ) {
      map.set(key, result);
    }
  }
  return Array.from(map.values());
}

